import React from 'react';
import { observer } from 'mobx-react-lite';
import { getRootStoreInstance, useRootStore } from 'store/rootStore';
import ProductLineTitle from 'components/common/general/ProductLineTitle';
import UwValidationResult from 'components/review-submit/UwValidationResult';
import { toJS } from 'mobx';
import { sortByProductLineId } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { RatesComparisonCard } from 'components/common/uw-review/RatesComparisonCard';
import { Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useHistory, useParams } from 'react-router-dom';
import { isRenewOrCancelProductLine } from 'global/services-helpers/enrollmentService';
import { EnrollmentStage } from 'types/enrollmentService';
import { imCelticsRights, uwRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import {
  OverrideRatesButtonStyled,
  ProductLineHeaderStyled,
  ResultsCardStyled,
  UWResultsSectionHeaderStyled,
} from './styles';

const ReviewSubmitResults: React.FC = observer(() => {
  const {
    reviewSubmitStore: { uwResults, isNewSaleEnrollmentPeriod, enrollmentModule, enrollmentPeriodCannotBeResubmitted },
  } = useRootStore();
  const { periodId } = useParams<{ periodId: string }>();
  const history = useHistory();

  const rootStore = getRootStoreInstance();

  const results = uwResults.result.map((dateObj) => toJS(dateObj)).slice();

  return (
    <div>
      <UWResultsSectionHeaderStyled>Underwriting Results</UWResultsSectionHeaderStyled>
      {results
        .sort((a, b) => {
          return sortByProductLineId(a.productLineId, b.productLineId);
        })
        .map((result) => (
          <ResultsCardStyled key={result.productLineId}>
            <ProductLineHeaderStyled>
              <ProductLineTitle productLineId={result.productLineId} />
              {((uwRights(rootStore.userStore.userRoles) &&
                enrollmentModule.enrollmentCoreData?.stage === EnrollmentStage.ENROLLING) ||
                (enrollmentModule.enrollmentCoreData?.stage === EnrollmentStage.SUBMITTED &&
                  (imCelticsRights(rootStore.userStore.userRoles) || enrollmentPeriodCannotBeResubmitted))) && (
                <OverrideRatesButtonStyled
                  type="text"
                  color="primary"
                  size="small"
                  leftIconProp={<Edit width="2.2rem" height="2.2rem" />}
                  onClick={() => {
                    // TO_DO: Remove this abhorring mutant of code into the pageStore where it belongs.
                    history.push(
                      `/override-uw-rates/${periodId}/${
                        enrollmentModule.enrollmentProposalData?.confirmedProposal?.cartId
                      }/${encodeURIComponent(
                        enrollmentModule.enrollmentProposalData?.confirmedProposal?.productLines.find(
                          (line) => line.id === result.productLineId,
                        )?.confirmedPortfolioId || '',
                      )}/${result.productLineId}`,
                    );
                  }}
                >
                  Override Final Rates
                </OverrideRatesButtonStyled>
              )}
            </ProductLineHeaderStyled>
            {isNewSaleEnrollmentPeriod && (
              <>
                {result.uwValidationResult.map((uwResult) => (
                  <UwValidationResult
                    status={uwResult.status}
                    message={uwResult.message}
                    key={`${uwResult.name}_${result.productLineId}`}
                  />
                ))}
              </>
            )}
            <RatesComparisonCard
              result={result}
              isRenewOrCancelProductLine={isRenewOrCancelProductLine(
                result.productLineId,
                enrollmentModule.enrollmentProposalData?.confirmedProposal,
              )}
            />
          </ResultsCardStyled>
        ))}
    </div>
  );
});

export default ReviewSubmitResults;
